export const EVENT_BACKGROUNDS = {
  default: { label: 'Default', color: 'oklch(0.98 0.005 80)' },
  white: { label: 'White', color: 'oklch(1 0 0)' },
  ivory: { label: 'Ivory', color: 'oklch(0.96 0.01 80)' },
  cream: { label: 'Cream', color: 'oklch(0.95 0.06 85)' },
  peach: { label: 'Peach', color: 'oklch(0.94 0.04 46)' },
  sage: { label: 'Sage', color: 'oklch(0.93 0.02 150)' },
} as const

export type EventBackground = keyof typeof EVENT_BACKGROUNDS

export function resolveBackgroundColor(key: string | null | undefined): string {
  if (!key) return EVENT_BACKGROUNDS.default.color
  const entry = EVENT_BACKGROUNDS[key as EventBackground]
  return entry ? entry.color : EVENT_BACKGROUNDS.default.color
}
